import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=5a491dcc&scoped=true&"
import script from "./Payments.vue?vue&type=script&lang=js&"
export * from "./Payments.vue?vue&type=script&lang=js&"
import style0 from "./Payments.vue?vue&type=style&index=0&id=5a491dcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a491dcc",
  null
  
)

export default component.exports